import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import TimeOff from '../../entities/timeOff';

/*
 * Delete/nullify anywhere this timeOff is used in other entities
 *
 * @param {TimeOff} timeOff
 */
export function deleteTimeOff(timeOff: TimeOff, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = timeOff.id;
    }

    /* Remove the actual timeOff */
    timeOff.status = 'D';
    timeOff.addedOn = newHRTimestamp();
    timeOff.addedBy = getCurrentUserId();
    timeOff.importSource = targetImportSource;
    timeOff.importId = mergeId;
    store.dispatch(Actions.TimeOffActions.removeTimeOffQueue(timeOff));
    
}